var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert-orange",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "alert-orange-1",
    d: "m13 0 13 22H0L13 0zm-.012 16.602-.109.003a1.853 1.853 0 0 0-1.736 1.853c0 .96.763 1.774 1.736 1.83l.11.004.11-.004a1.852 1.852 0 0 0 1.755-1.72l.003-.11-.003-.108a1.857 1.857 0 0 0-1.866-1.748zm1.405-8.762h-2.786l.367 7.378h1.985l.434-7.378z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-orange-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "alert-orange-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "alert-orange-4",
    xlinkHref: "#alert-orange-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "alert-orange-5",
    fill: "#FFF",
    mask: "url(#alert-orange-3)",
    d: "M-2 25h31V-2H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "alert-orange-6",
    fill: "#FFA800",
    mask: "url(#alert-orange-3)",
    d: "M-4 28h34V-6H-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOrange);
export default __webpack_public_path__ + "static/media/alert-orange.4b6fe0b4d77e5b523c44ccd63f550856.svg";
export { ForwardRef as ReactComponent };